import * as gateway from 'sfx-web-contract';
import { ISeverityCodeType, IStreamData } from '../../interfaces';

const severityMap = new Map<gateway.SeverityCode, ISeverityCodeType>([
    [ gateway.SeverityCode.SEVERITYCODE_ERROR, 'error' ],
    [ gateway.SeverityCode.SEVERITYCODE_INFO, 'info' ],
    [ gateway.SeverityCode.SEVERITYCODE_WARNING, 'warning' ],
]);

/**
* Format envelop to stream data with error and meta info
* @param envelop ResponseEnvelop
*/
export function createStreamData(envelop: gateway.EnvelopeResponse): IStreamData<Uint8Array> {

    const streamData = {
        communicationToken: envelop.requestId,
    } as IStreamData<Uint8Array>;

    if (Boolean(envelop.error)) {
        const error = envelop.error as gateway.ResponseError;

        streamData.error = {
            code: error.errorCode,
            severity: severityMap.get(error.severityCode),
            message: error.errorMessage.value,
            isAutoCloseMessage: error.isAutoCloseMessage,
        };

        streamData.payload = new Uint8Array();
    } else {
        streamData.payload = envelop.nestedMessage?.value ?? new Uint8Array();
    }

    streamData.terminal = envelop.terminal;

    return streamData;
}
